// extracted by mini-css-extract-plugin
export default {"container":"style_container__ciHtE","nav_link":"style_nav_link__cqi11","copyright":"style_copyright__c46FS"};